import React, { useEffect, useState, useContext, useMemo } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledWipDetalhesPage } from "../../../styled-components/StyledWipDetalhesPage.style";
import { Footer } from "../../../components/Footer";
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { useTable, useSortBy, useFilters } from "react-table";
import IntlCurrencyInput from "react-intl-currency-input";
import { useLocation } from "react-router-dom";
import logo from "../../../assets/criterio-experts.png";
import { ModalObservacao } from "../../../components/ModalObservacao";
import { ModalExportar } from "../../../components/ModalExportar";
import { useHistory } from "react-router-dom";
import * as moment from 'moment'

const ExcelJS = require('exceljs');

const getLista = async () => {
    let list = null;
    try {
        const response = await api.get(`WIP/detalhado/${window.location.search}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

export const WIPDetalhes = () => {
    const history = useHistory();
    var [timesheets, setTimesheets] = useState([]);
    var [visao, setVisao] = useState([]);
    const [modalObservacoes, setmodalObservacoes] = useState(false);
    const [selectedIdTimesheet, setSelectedIdTimesheet] = useState(null);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [columns, setColumns] = useState([]);

    const afterNotifyGrupoOpenModal = () => { };

    const openModalObservacoesOpen = () => {
        setmodalObservacoes(true);
    };

    const closeModalObservacoes = () => {
        setmodalObservacoes(false);
    }

    const ColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;
        return (
            <input
                value={filterValue || ""}
                onChange={e => {
                    setFilter(e.target.value || undefined);
                }}
                placeholder={`Filtrar`}
                className={`width-${inputFilterClass}`}
            />
        );
    };

    const MoneyColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;

        return (
            <IntlCurrencyInput
                currency="BRL"
                config={currencyConfig}
                defaultValue={filterValue || ""}
                onChange={(_event, value, _maskedValue) => {
                    setFilter(value || undefined);
                }}
                style={{
                    width: `${inputFilterClass}px`,
                    textAlign: "right"
                }}
            />
        );
    };

    const MoneyRangeColumnFilter = ({ column: { filterValue = [], preFilteredRows, setFilter, id }, }) => {
        const [min, max] = useMemo(() => {
            let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            preFilteredRows.forEach(row => {
                min = Math.min(row.values[id], min)
                max = Math.max(row.values[id], max)
            })
            return [min, max]
        }, [id, preFilteredRows])

        return (
            <div
                style={{
                    display: 'flex',
                }}
            >
                <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    defaultValue={filterValue[0] || ''}
                    onChange={(_event, value, _maskedValue) => {
                        setFilter((old = []) => [value ? value : undefined, old[1]])
                    }}
                    style={{
                        width: '100px',
                        marginRight: '10px',
                        textAlign: "right"
                    }}
                />
                <div className="pt-2">Até</div>
                <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    defaultValue={filterValue[1] || ''}
                    onChange={(_event, value, _maskedValue) => {
                        setFilter((old = []) => [old[0], value ? value : undefined])
                    }}
                    style={{
                        width: '100px',
                        marginLeft: '10px',
                        textAlign: "right"
                    }}
                />
            </div>
        )
    }

    const NumberRangeColumnFilter = ({ column: { filterValue = [], preFilteredRows, setFilter, id }, }) => {
        const [min, max] = useMemo(() => {
            let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            preFilteredRows.forEach(row => {
                min = Math.min(row.values[id], min)
                max = Math.max(row.values[id], max)
            })
            return [min, max]
        }, [id, preFilteredRows])

        return (
            <div
                style={{
                    display: 'flex',
                }}
            >
                <input
                    value={filterValue[0] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
                    }}
                    placeholder={`Min`}
                    style={{ width: '80px', marginRight: '10px' }}
                />
                <div className="pt-2">Até</div>
                <input
                    value={filterValue[1] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
                    }}
                    placeholder={`Max`}
                    style={{ width: '80px', marginLeft: '10px' }}
                />
            </div>
        )
    }

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';
        }

        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const reduzirString = (texto, limite) => {
        if (texto && texto?.length > limite) {
            return texto.slice(0, limite) + '...';
        } else {
            return texto;
        }
    }

    const getCutText = (text, size) => {

        if (!text) {
            return '';
        }

        if (text.length <= size) {
            return text;
        }


        return (
            <span title={text}>{reduzirString(text, size)}</span>
        );

    };

    var mostrarDesconto = window.location.search.indexOf("IdPeritos") < 0;

    columns = useMemo(
        () => [
            {
                Header: "I",
                hideHeader: false,
                columns: [
                    {
                        Header: "Laudo",
                        accessor: "pericia.sigla",
                        className: "text-left",
                        inputFilterClass: "70"
                    },
                    {
                        Header: "TS",
                        accessor: "timesheet.numeroTimesheet",
                        className: "text-center",
                        classNameFooter: "text-center legend-value",
                        inputFilterClass: "50",
                        Footer: info => {
                            return <> {info.rows.length}</>
                        },
                    },
                    {
                        Header: "Vida Útil",
                        accessor: "timesheet.vidaUtil",
                        className: "text-center",
                        inputFilterClass: "60",
                        Cell: (props) => {
                            return (<span className="badge bg-lightblue" >{props.row.original.timesheet.vidaUtil}</span>)
                        }
                    },
                    ...(visao === "Timesheet (Em Andamento)"
                    ? [
                        { 
                            Header: () => <span title="Quantidade Dias Sem Movimentação">Qtd. Dias S/M</span>,
                            accessor: "timesheet.diasSemMovimentacao",
                            className: "text-center",
                            inputFilterClass: "60",
                            Cell: (props) => {
                                return (<span className="badge bg-lightblue" >{props.row.original.timesheet.diasSemMovimentacao}</span>)
                            }
                        }
                      ]
                    : []),
                    {
                        Header: "Horas",
                        accessor: "timesheet.totalHorasFaturadas",
                        className: "text-right",
                        classNameFooter: "text-right legend-value",
                        Cell: (props) => {
                            return <div>{formatDecimal(props.cell.value)}</div>;
                        },
                        Footer: info => {
                            const total = React.useMemo(
                                () =>
                                    info.rows.reduce((sum, row) => row.original.timesheet.totalHorasFaturadas + sum, 0),
                                [info.rows]
                            )
                            return <> {formatDecimal(total)}</>
                        },
                        inputFilterClass: "50",
                    },
                    {
                        Header: mostrarDesconto ? "SubTotal" : "Valor Total",
                        accessor: "timesheet.valorTotalFaturado",
                        className: "text-right",
                        classNameFooter: "text-right legend-value",
                        filter: 'money',
                        Cell: (props) => {
                            return <div>{props.cell.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</div>;
                        },
                        Footer: info => {
                            const total = React.useMemo(
                                () =>
                                    info.rows.reduce((sum, row) => row.original.timesheet.valorTotalFaturado + sum, 0),
                                [info.rows]
                            )
                            return <> {total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</>
                        },
                        Filter: MoneyColumnFilter,
                        inputFilterClass: "90",
                    },
                    {
                        Header: "Desconto",
                        accessor: "timesheet.valorTotalDesconto",
                        className: "text-right" + (mostrarDesconto ? "" : " display-none"),
                        classNameFooter: "text-right legend-value" + (mostrarDesconto ? "" : " display-none"),
                        classnameHeader: mostrarDesconto ? "" : "display-none",
                        filter: 'money',
                        Cell: (props) => {
                            return <div>{props.cell.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</div>;
                        },
                        Footer: info => {
                            const total = React.useMemo(
                                () =>
                                    info.rows.reduce((sum, row) => row.original.timesheet.valorTotalDesconto + sum, 0),
                                [info.rows]
                            )
                            return <> {total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</>
                        },
                        Filter: MoneyColumnFilter,
                        inputFilterClass: "90",
                    },
                    {
                        Header: "Valor Total",
                        accessor: "timesheet.valorTotalGeralFaturado",
                        className: "text-right" + (mostrarDesconto ? "" : " display-none"),
                        classNameFooter: "text-right legend-value" + (mostrarDesconto ? "" : " display-none"),
                        classnameHeader: mostrarDesconto ? "" : "display-none",
                        filter: 'money',
                        Cell: (props) => {
                            return <div>{props.cell.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</div>;
                        },
                        Footer: info => {
                            const total = React.useMemo(
                                () =>
                                    info.rows.reduce((sum, row) => row.original.timesheet.valorTotalGeralFaturado + sum, 0),
                                [info.rows]
                            )
                            return <> {total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</>
                        },
                        Filter: MoneyColumnFilter,
                        inputFilterClass: "90",
                    },
                    {
                        Header: "Seguradora",
                        accessor: "cliente",
                        className: "text-left",
                        inputFilterClass: "110",
                        Cell: (props) => {
                            return getCutText(props?.row?.original?.cliente, 30);
                        },
                    },
                    {
                        Header: "Segurado",
                        accessor: "segurado",
                        className: "text-left",
                        inputFilterClass: "110",
                        Cell: (props) => {
                            return getCutText(props?.row?.original?.segurado, 30);
                        },
                    },
                    {
                        Header: "Sinistro",
                        accessor: "sinistro.numeroSinistro",
                        className: "text-left",
                        inputFilterClass: "150",
                    },
                    {
                        Header: "Analista",
                        accessor: "sinistro.analista",
                        className: "text-left",
                        inputFilterClass: "110",
                        Cell: (props) => {
                            return getCutText(props?.row?.original?.sinistro.analista, 20);
                        },
                    },
                    {
                        Header: "Líder",
                        accessor: "pericia.liderPericia",
                        className: "text-left",
                        Cell: (props) => {
                            return getCutText(props?.row?.original?.pericia.liderPericia, 20);
                        },
                        inputFilterClass: "110"
                    },
                    {
                        Header: "Status aprovação",
                        Footer: "",
                        accessor: "aprovacao.statusAprovacao",
                        className: "text-left",
                        inputFilterClass: "100"
                    },
                    {
                        Header: "Etapa aprovação",
                        Footer: "",
                        accessor: "aprovacao.nomeAprovacao",
                        className: "text-left",
                        inputFilterClass: "190"
                    },
                    {
                        Header: "Data de envio",
                        Footer: "",
                        accessor: "aprovacao.dataEnvio",
                        className: "text-left",
                        inputFilterClass: "100"
                    },
                    {
                        Header: "Prazo da aprovação",
                        Footer: "",
                        accessor: "aprovacao.dataPrazo",
                        className: "text-left",
                        inputFilterClass: "110",
                        Cell: (props) => {
                            var item = props.row.original;
                            var classe = "";
                            if (!item.aprovacao || item.aprovacao.statusAprovacao !== "Pendente") {
                                classe = "";
                            }
                            else {
                                var diasPassadosEmPorcentagem = item.aprovacao.diasRestantes * 100 / item.aprovacao.prazo

                                if (item.aprovacao.diasRestantes < 0) {
                                    classe = "error";
                                }
                                else if (diasPassadosEmPorcentagem <= 70) {
                                    classe = "warning";
                                }
                                else {
                                    classe = "success";
                                }
                            }

                            return <div className={`prazo-${classe}`}><i className="fa fa-circle"></i> {props.cell.value}</div>;
                        },
                    },
                    {
                        Header: "Disciplina",
                        accessor: "disciplina",
                        className: "text-center",
                        tag: true,
                        canFilter: true,
                        inputFilterClass: "80"
                    },
                    {
                        Header: "Apolice",
                        accessor: "sinistro.numeroApolice",
                        className: "text-left"
                    },
                    {
                        Header: "Tipo TS",
                        accessor: "timesheet.tipoTimesheet",
                        className: "text-left"
                    },
                    {
                        Header: "Tipo Sinistro",
                        accessor: "pericia.tipoSinistro",
                        className: "text-left"
                    },
                    {
                        Header: "Obs.",
                        Footer: "",
                        accessor: "",
                        className: "text-center hover",
                        Cell: (props) => {
                            var item = props.row.original;
                            return <div onClick={() => openObservacoes(item.timesheet.idTimesheet)}>
                                <i className="fa fa-comments-o fa-lg" aria-hidden="true"></i>
                            </div>;
                        },
                        inputFilterClass: "60"
                    }
                ]
            }
        ],
        [visao]
    );

    const openObservacoes = (idTimesheet) => {
        setSelectedIdTimesheet(idTimesheet)
        openModalObservacoesOpen()
    }

    const filterTypes = {
        text: (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValue = row.values[id];
                return rowValue !== undefined ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true;
            });
        }
    };
    const defaultColumn = { Filter: ColumnFilter };
    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        footerGroups,
        rows, // rows for the table based on the data passed
        prepareRow // Prepare the row (this function needs to be called for each row before getting the row props)
    } = useTable({ columns, data: timesheets, defaultColumn, filterTypes }, useFilters, useSortBy);

    const loadData = async () => {
        const lista = await getLista();
        setVisao(lista?.data?.visao)
        setTimesheets(lista?.data?.data)
    };

    useEffect(() => { loadData(); }, [10]);

    const voltar = async () => {
        history.push(`/wip${window.location.search}`)
    }

    const getDateByDateTime = (date) => {
        if (date) {
            return date.split(' ')[0];
        }
        return '';
    }

    const [modalWIPDetalheExportar, setModalWIPDetalheExportar] = useState(false);
    const openModalWIPDetalheExportar = () => { setModalWIPDetalheExportar(true); }
    const closeModalWIPDetalheExportar = (currentValue, value) => { setModalWIPDetalheExportar(false); }

    const handleExportarRelatorio = async () => {
        const search = history.location.search || '';
        const usp = new URLSearchParams(search);

        // 2. Verifica se é pesquisa avançada
        const isPesquisaAvancada = usp.get('pesquisaAvancada') === 'true';

        // 3. Monta o payload base (Sempre leva Visão e IdEmpresa)
        let formValues = {
            visao: usp.get('visao'),
            idEmpresa: parseInt(usp.get('IdEmpresa'))
        };

        // 4. Se for true, adiciona os outros parâmetros
        if (isPesquisaAvancada) {
            formValues.idDisciplinas = usp.getAll('IdDisciplinas').map(item => parseInt(item, 10));
            formValues.idPeritos = usp.getAll('IdPeritos').map(item => parseInt(item, 10));
            formValues.idLideres = usp.getAll('IdLideres').map(item => parseInt(item, 10));
            formValues.idClientes = usp.getAll('IdClientes').map(item => parseInt(item, 10));
            formValues.segurado = usp.get('Segurado');
            formValues.sigla = usp.get('Sigla');
            formValues.analista = usp.get('Analista');
        }

        Object.keys(formValues).forEach(key => {
            if (Array.isArray(formValues[key]) && formValues[key].length === 0) {
                formValues[key] = null; 
                // Dica: Se 'null' ainda der erro de bind no back, troque a linha de cima por:
                // delete formValues[key];
            }
        });

        console.log('Valores que vão para o Back:', formValues);

        try {
            const response = await api.post(`Wip/detalhado/export`, formValues, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let fileName = `Meritocracia_${moment().format('DDMMYYYY')}.xlsx`;

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
                if (fileNameMatch && fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            return true;

        } catch (error) {
            console.error("Erro ao exportar", error);
            throw error;
        }
    }

    const exportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("serviços");
        const imageId2 = workbook.addImage({
            base64: logo,
            extension: 'png',
        });
        worksheet.addImage(imageId2, 'A1:B3');
        worksheet.autoFilter = 'A5:J5';
        worksheet.getRow(5).values = [
            "Laudo",
            "Vida Útil",
            ...(visao === "Timesheet (Em Andamento)" ? ["Qtd. Dias S/M"] : []),
            'Horas Totais',
            'Valor Total',
            "Data Envio",
            "Previsão Faturamento",
            "Dias Pendentes",
            'Seguradora',
            "Analista",
            "Segurado",
            "Líder",
            'Tipo Sinistro',
            "Sinistro",
            "Status TS",
            "Etapa Aprovação",
            "Status Aprovação",
            "Apolice",
            'Disciplina',
            'Tipo TS',
        ];
        worksheet.columns = [
            { key: "Laudo", width: 15 },
            { key: "Vida Útil", width: 15 },
            ...(visao === "Timesheet (Em Andamento)" ? [{ key: "Qtd. Dias S/M", width: 15 }] : []),            
            { key: 'Horas Totais', width: 18 },
            { key: 'Valor Total', width: 17 },
            { key: 'Data Envio', width: 30 },
            { key: 'Previsão Faturamento', width: 30 },
            { key: 'Dias Pendentes', width: 30 },
            { key: 'Seguradora', width: 30 },
            { key: 'Analista', width: 30 },
            { key: "Segurado", width: 30 },
            { key: "Líder", width: 30 },
            { key: 'Tipo Sinistro', width: 30 },
            { key: "Sinistro", width: 30 },
            { key: 'Status TS', width: 30 },
            { key: 'Etapa Aprovação', width: 30 },
            { key: 'Status Aprovação', width: 30 },
            { key: "Apolice", width: 30 },
            { key: 'Disciplina', width: 15 },
            { key: 'Tipo TS', width: 15 },
        ];

        worksheet.getRow(5).eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "EE4B21" }, // Cor de fundo (azul escuro)
            };
            cell.font = {
                color: { argb: "FFFFFF" }, // Fonte branca
                bold: true,
                size: 12,
            };
            cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
            };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        worksheet.getRow(5).eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        rows.sort((a, b) => {
            const vidaUtilA = Number(a.original.timesheet.vidaUtil);
            const vidaUtilB = Number(b.original.timesheet.vidaUtil);
            return vidaUtilB - vidaUtilA;
        });

        rows.map(timesheet => {
            worksheet.addRow({
                "Laudo": timesheet.original.pericia.sigla,
                "Vida Útil": Number(timesheet.original.timesheet.vidaUtil),
                ...(visao === "Timesheet (Em Andamento)" ? {
                    "Qtd. Dias S/M": Number(timesheet.original.timesheet.diasSemMovimentacao),
                } : {}),
                "Horas Totais": Number(timesheet.original.timesheet.totalHorasFaturadas),
                "Valor Total": mostrarDesconto ? timesheet.original.timesheet.valorTotalGeralFaturado : timesheet.original.timesheet.valorTotalFaturado,
                "Data Envio": getDateByDateTime(timesheet.original.aprovacao.dataEnvio),
                "Previsão Faturamento": getDateByDateTime(timesheet.original.aprovacao.previsaoFaturamento),
                "Dias Pendentes": timesheet.original.aprovacao.diasPendente,
                "Seguradora": timesheet.original.cliente,
                "Analista": timesheet.original.sinistro.analista,
                "Segurado": timesheet.original.segurado,
                "Líder": timesheet.original.pericia.liderPericia,
                "Tipo Sinistro": timesheet.original.pericia.tipoSinistro,
                "Sinistro": timesheet.original.sinistro.numeroSinistro,
                "Status TS": timesheet.original.timesheet.statusTimesheet,
                "Etapa Aprovação": timesheet.original.aprovacao.nomeAprovacao == null ? '' : timesheet.original.aprovacao.nomeAprovacao,
                "Status Aprovação": timesheet.original.aprovacao.statusAprovacao,
                "Apolice": timesheet.original.sinistro.numeroApolice,
                "Disciplina": timesheet.original.disciplina,
                "Tipo TS": timesheet.original.timesheet.tipoTimesheet,
            });
        })

        const startRow = 6; // os dados começam na linha 6
        rows.forEach((_, index) => {
            const rowNumber = startRow + index;
            worksheet.getRow(rowNumber).eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        rows.forEach((_, index) => {
            const rowNumber = startRow + index;
            
            const cell = worksheet.getRow(rowNumber).getCell(2); // Coluna B (segunda coluna)
            cell.numFmt = '0'; // Formato inteiro, sem casas decimais

            if(visao === "Timesheet (Em Andamento)") {
                const cell = worksheet.getRow(rowNumber).getCell(3); // Coluna B (segunda coluna)
                cell.numFmt = '0';

                const cellDecimal2 = worksheet.getRow(rowNumber).getCell(4); // Coluna C
                cellDecimal2.numFmt = '#,##0.00'; // Duas casas decimais com separador de milhar


                const cellMoeda = worksheet.getRow(rowNumber).getCell(5);
                cellMoeda.numFmt = '[$R$-1] #,##0.00;[Red][$R$-1] -#,##0.00';

                const cellDataEnvio = worksheet.getRow(rowNumber).getCell(6); // Coluna E
                const cellPossivelFaturamento = worksheet.getRow(rowNumber).getCell(7); // Coluna F

                const cellDiasPendentes = worksheet.getRow(rowNumber).getCell(8);
                cellDiasPendentes.numFmt = '0';

                cell.alignment = cellDecimal2.alignment = cellMoeda.alignment = 
                cellDiasPendentes.alignment = cellDataEnvio.alignment = 
                cellPossivelFaturamento.alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                };
            }
            
            else 
            {
                const cellDecimal2 = worksheet.getRow(rowNumber).getCell(3); // Coluna C
                cellDecimal2.numFmt = '#,##0.00'; // Duas casas decimais com separador de milhar


                const cellMoeda = worksheet.getRow(rowNumber).getCell(4);
                cellMoeda.numFmt = '[$R$-1] #,##0.00;[Red][$R$-1] -#,##0.00';

                const cellDataEnvio = worksheet.getRow(rowNumber).getCell(5); // Coluna E
                const cellPossivelFaturamento = worksheet.getRow(rowNumber).getCell(6); // Coluna F

                const cellDiasPendentes = worksheet.getRow(rowNumber).getCell(7);
                cellDiasPendentes.numFmt = '0';

                cell.alignment = cellDecimal2.alignment = cellMoeda.alignment = 
                cellDiasPendentes.alignment = cellDataEnvio.alignment = 
                cellPossivelFaturamento.alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                };
            }

            
        });

        worksheet.mergeCells('A1:S4');
        

        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `WIP_${visao}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledWipDetalhesPage>
                    <div className="w-100 d-flex justify-content-between align-items-center mb-3">
                        <div className="title-row">
                            <h5 className="title-row-header">{visao}</h5>
                        </div>
                        <div>
                            <input type="button" className='default-button ml-3' value='Voltar' onClick={voltar} />
                            {
                                timesheets.length > 0 && (<input type="button" className='default-button-red ml-3' value='Exportar' onClick={openModalWIPDetalheExportar} />)
                            }
                        </div>
                    </div>

                    <div className="card timesheet">
                        <StyledTablePage>
                            <div className="table-container">
                                <table {...getTableProps()} className="table table-bordered table-width table-sm">
                                    <thead>
                                        {headerGroups.map((headerGroup) => (
                                            <>
                                                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                    {headerGroup.headers.map((column) => {
                                                        return column.hideHeader === false ? null : (
                                                            <th {...column.getHeaderProps(column.getSortByToggleProps())} className={`${column?.classnameHeader}`}>
                                                                {column.render("Header")}
                                                                <span style={{ marginLeft: '3px' }}>
                                                                    {
                                                                        column.isSorted
                                                                            ? column.isSortedDesc
                                                                                ? <svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" /></svg>
                                                                                : <svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" /></svg>
                                                                            : null
                                                                    }
                                                                </span>
                                                            </th>
                                                        );
                                                    }
                                                    )}
                                                </tr>
                                                <tr {...headerGroup.getHeaderGroupProps()}>
                                                    {headerGroup.headers.map((column) => {
                                                        return column.hideHeader === false ? null : (
                                                            <th className={`${column?.classnameHeader}`}>
                                                                <div>{column.canFilter ? column.render("Filter") : null}</div>
                                                            </th>
                                                        );
                                                    }
                                                    )}
                                                </tr>
                                            </>
                                        ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()}>
                                        {rows.map((row, i) => {
                                            prepareRow(row);
                                            return (
                                                <tr {...row.getRowProps()} className={`table-data-info `}>
                                                    {row.cells.map((cell, i) => {
                                                        return (
                                                            <td {...cell.getCellProps()} className={`${cell.column.className}`+(`${row.original.timesheet.pendenteDeEsclarecimento && ' esclarecimentoCard' }`)}>
                                                                <div className={`${(row?.cells[i].column?.tag && 'badge badge-secondary')}` + ` ${row?.cells[i].column?.className}`}>
                                                                    {cell.render("Cell")}
                                                                </div>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot>
                                        {footerGroups.map((footerGroup) => (
                                            <tr {...footerGroup.getFooterGroupProps()}>
                                                {footerGroup.headers.map((cell, i) => {
                                                    if (cell.accessor) {
                                                        return (
                                                            <td className={`${cell?.classNameFooter}`} >{cell.Footer && cell.render('Footer')}</td>
                                                        );
                                                    }

                                                })}
                                            </tr>
                                        ))}
                                    </tfoot>
                                </table>
                            </div>
                        </StyledTablePage>
                    </div>
                    <ModalObservacao
                        isOpen={modalObservacoes}
                        onAfterOpen={afterNotifyGrupoOpenModal}
                        onRequestClose={closeModalObservacoes}
                        idTimesheet={selectedIdTimesheet}
                    >
                    </ModalObservacao>
                    <ModalExportar
                        key={"ModalWIPDetalheExportar"}
                        isOpen={modalWIPDetalheExportar}
                        onRequestClose={closeModalWIPDetalheExportar}
                        setIsOpen={() => setModalWIPDetalheExportar(false)}
                        onExportar={handleExportarRelatorio}
                    ></ModalExportar>
                </StyledWipDetalhesPage>
            </main>

        </section>
    );
};

export const WIPDetalhesPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <WIPDetalhes />

                </>
            )}
        </>
    );
};